import { motion } from 'framer-motion';
import Button from './Button';

const FinalCTA = () => {
  return (
    <section className="py-24 md:py-32 px-4 md:px-8 bg-navy text-center overflow-hidden relative" id="Contact">
      {/* Background decorations */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden opacity-20 pointer-events-none">
        <div className="absolute top-10 left-10 w-64 h-64 border-4 border-pink rounded-full blur-3xl" />
        <div className="absolute bottom-10 right-10 w-96 h-96 bg-accent rounded-full blur-3xl" />
      </div>

      <motion.div 
        initial={{ scale: 0.9, opacity: 0 }}
        whileInView={{ scale: 1, opacity: 1 }}
        viewport={{ once: true }}
        transition={{ duration: 0.5 }}
        className="max-w-4xl mx-auto relative z-10"
      >
        <h2 className="font-semibold text-4xl sm:text-5xl md:text-6xl lg:text-7xl mb-8 md:mb-12 leading-tight text-white">
          Ready to scale your <br />
          <span className="relative inline-block mt-2">
            <span className="relative z-10">game?</span>
            <svg className="absolute w-[110%] h-6 md:h-8 -bottom-1 md:-bottom-2 left-[-5%] text-pink z-0 pointer-events-none" viewBox="0 0 200 20" preserveAspectRatio="none">
              <motion.path 
                d="M5,12 C50,18 100,5 195,12" 
                fill="none" 
                stroke="currentColor" 
                strokeWidth="8" 
                strokeLinecap="round"
                initial={{ pathLength: 0 }}
                whileInView={{ pathLength: 1 }}
                viewport={{ once: true }}
                transition={{ duration: 1, delay: 0.3 }}
              />
            </svg>
          </span>
        </h2>

        <div className="w-64 mx-auto">
          <Button link="https://discord.gg/sy5k53rkz4" theme="inverse">
            Book a Discovery Call
          </Button>
        </div>
        
        <p className="mt-6 md:mt-8 text-muted font-medium">
          Guaranteed results. No growth, no pay.
        </p>
      </motion.div>
    </section>
  );
};

export default FinalCTA;